$(document).ready(function(){
  // Shop dropdown load images on first hover
  var shopDropRendered = 0;
  $('.site-nav .site-nav--shop').hover(function(){
    shopDropRendered++;
    if(shopDropRendered == 1){
      $('.site-nav .site-nav--shop img').each(function(){
        $(this).attr('src',$(this).data('img-src'));
      });
    }
  });

  // Cart dropdown load images on first hover
  var cartSummaryRendered = 0;
  $('#cart-summary').hover(function(){
    cartSummaryRendered++;
    if(cartSummaryRendered == 1){
      $('#cart-summary img').each(function(){
        $(this).attr('src',$(this).data('img-src'));
      });
    }
  });

  // Get current cart contents
  function updateCartSummary(){
    $.getJSON('/cart.js',function(cart){renderCartSummary(cart);});
  }

  // Build/Update cart summary
  function renderCartSummary(cart){
    var cartItemCount = cart.item_count;
    if (cartItemCount == 0){
      $('.cart-summary').html('<div class="text-center">Your cart is currently empty.</div>');
    } else {
      $('.CartCount').text(cartItemCount); // update item count in header
      $('.cart-summary').html('<div class="cart-summary__items"></div>');
      var cartItems = cart.items;      
      for (i = 0; i < cartItems.length; i++) { // loop through items and build list
        var itemType = '';
        $.ajax({
          dataType: "json",
          url: '/products/'+cartItems[i].handle+'.js',
          async: false,
          success: function(product){
            itemType = product.type;
            if (itemType == 'Accessory' || itemType == 'Repair') {itemType = '';}
          }
        });
        if (cartItems[i].image != null){
          var itemImage = cartItems[i].image.replace('.png','_50x50.png');
        } else {
          var itemImage = "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_50x50.gif";
        }
        var itemHTML = '<div class="cart-summary__item display-table"><div class="cart-summary__image display-table-cell"><img src="'+itemImage+'" ></div><div class="cart-summary__info display-table-cell"><a href="'+cartItems[i].url+'">'+cartItems[i].product_title+'</a><span class="type">'+itemType+'</span><span class="price">'+theme.Currency.formatMoney(cartItems[i].line_price, '${{amount}}').replace('.00','')+'</span></div></div>';
        $('.cart-summary__items').append(itemHTML);
      }   
      var checkoutPath = (ktwhSpec && ktwhSpec.customer) ? '/cart#wholesale' : '/checkout';
      $('.cart-summary').append('<div class="cart-summary__button"><a href="'+ checkoutPath +'" class="btn btn--full">Checkout</a></div>');
      $('.cart-link.cart-summary__link .cart-link__text').text('View/Edit Cart');
    }   
  } 

  // Ajax Add to Cart
  $('a.add-product-to-cart, button.product-form__cart-submit').click(function(e){
    e.preventDefault();
    $actionTarget = $(this);
    if($(this).hasClass('add-product-to-cart')) {
      var variantID = $(this).data('variant-id'), 
          $actionTargetParent = $actionTarget.parent(),
          ajaxAddData = 'id=' + variantID + '&quantity=1'; 
    } else {
      var variantID = $('select.product-form__variants').val(), 
          $actionTargetParent = $actionTarget.closest('form'),
          ajaxAddData = $actionTargetParent.serialize();
    }
    $actionTargetParent.find('.form--error').remove();
    $.ajax({ 
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      cache: false, 
      data: ajaxAddData,
      dataType: 'json',
      success: function(product){
        updateCartSummary();      
        $('.site-nav li.cart-icon').addClass('nav-hover'); // Show cart summary      
        setTimeout(function(){$('.site-nav li.cart-icon').removeClass('nav-hover');}, 6000); // Hide after 6 seconds
      },
      error: function(jqXHR, textStatus, errorThrown){      
        var errorResponse = $.parseJSON(jqXHR.responseText), 
            errorResponseDescription = errorResponse.description,  
            errorMsg = '<div class="form--error">Error: '+ errorResponseDescription +'</div>';
        $actionTargetParent.append(errorMsg);
      }
    });
  });

  // Open Search Bar
  $('.site-header__open-search').click(function(e){
    e.preventDefault();
    $('#search-bar').animate({top: '0px'}, 500, function(){$('#search-bar input').focus();});
  });

  // Close Search Bar
  $('.close-search').click(function(){
    $('#search-bar').animate({ top: '-100%'}, 500);
  });

  // Accessories Filter
  if ($('#filter-accessories').length) {
    $('#filter-accessories').val('');
    $('#filter-accessories').change(function(){
      if($(this).val() == '') {
        $('#accessories-collection .collection-section').fadeIn();
      } else {
        var accessoriesSectionID = '#' + $(this).val();
      $('#accessories-collection .collection-section:not('+accessoriesSectionID+')').fadeOut('slow',function(){
        $(accessoriesSectionID).fadeIn(); 
      });
      }    
    });
  }

  // Sticky Cart Sidebar
  if ($('#sticky-sidebar').length) {
    var init_scrollTop = $(window).scrollTop(),
        headerHeight = $('#site-header').outerHeight(),
        init_sidewidth = $('#sticky-sidebar').width(),
        offsetTop = headerHeight + 30,
        init_sideoffsettop = $('#sticky-sidebar').offset().top - (offsetTop);
    
    if ($('.site-nav li.menu-icon').css('display').toLowerCase() == 'none'){ // if we're not on mobile size
      if (init_scrollTop > init_sideoffsettop) {
        $('#sticky-sidebar .sidebar').addClass('fixed').css('width', init_sidewidth);
      }   
    }
    function stickySidebar(){
      if ($('.site-nav li.menu-icon').css('display').toLowerCase() == 'none'){ // if we're not on mobile size
        var scrollTop = $(window).scrollTop(),
            new_sidewidth = $('#sticky-sidebar').width(),
            new_sideoffsettop = $('#sticky-sidebar').offset().top - (offsetTop),
            new_sideheight = $('#sticky-sidebar').outerHeight(),
            new_blockheight = $('#sticky-sidebar .sidebar').outerHeight(),
            new_sideoffsettop = $('#sticky-sidebar').offset().top - (offsetTop),
            bottomOffset = (new_sideheight + 80) - new_blockheight;   

        if (scrollTop > new_sideoffsettop && new_blockheight !== new_sideheight) {
          $('#sticky-sidebar .sidebar').addClass('fixed').css('width', new_sidewidth);
        } else {
          $('#sticky-sidebar .sidebar').removeClass('fixed').removeAttr('style');
        }
        if (scrollTop > bottomOffset){
          $('#sticky-sidebar .sidebar').addClass('bottom');
        } else {
          $('#sticky-sidebar .sidebar').removeClass('bottom'); 
        }  
      }
    }
    $(window).on('scroll resize', function() {
      stickySidebar();
    }).trigger('scroll');  
  }

  // See All Accessories
  $('.see-all-accessories').click(function(e){
    e.preventDefault();
    $(this).remove();
    var $el = $('#accessories');
    var accessoriesBottom = $el.offset().top + $el.outerHeight() - 60;
    $('.hide-accessory img').each(function(){
      $(this).attr('src',$(this).data('img-src'));
    });
    $('html,body').animate({
      scrollTop: accessoriesBottom
    }, 750, function(){$('.hide-accessory').show(0,function(){$(this).css('opacity','1'); });});   
  });

  // YouTube Video
  $('.play-youtube-video').click(function(){
    var videoID = $(this).data('video-id');
    $(this).parent().html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+videoID+'?rel=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>');
  });

  // YouTube Video in modal
  $(".open-video-modal").fancybox({
    helpers: { media: true},
    width: 1000,
    height: 563,
    aspectRatio: true,
    scrolling: 'no',
    autoResize: true
  });

  // Special links/buttons
  $('a.is-anchor').click(function(e){
    e.preventDefault();
    var target = $(this).attr('href');
    var animateTo = $(target).offset().top;
    if($(this).hasClass('advance-to-content-section')) {
      animateTo = animateTo - $('#site-header').outerHeight();
    }
    $('html,body').animate({scrollTop: animateTo}, 500);
  });

  // Animated Overlay Product Images
  if($('.content-section__overlay-img').length){
    enquire.register("screen and (min-width:768px)", {
      match : function() {
        var $overlayImgs = $('.content-section__overlay-img.show-me');
        $overlayImgs.each(function(){ // pre-load images
          var $thisImg = $(this).children('img');
          $thisImg.attr('src',$thisImg.data('original'));
        });  
        $(window).on('scroll', function(e){
          $overlayImgs.each(function(i,elem){
            if($(this).hasClass('shown')){return;}
            isScrolledIntoView($(this));
          });
        });
        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop() + 60;
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $(elem).parent().offset().top;
          var elemBottom = elemTop + ($(elem).parent().height() * .85);
          if((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) {
            $(elem).removeClass('show-me').addClass('shown');   
          }
        }
      }
    });
  }

  // Lazy Load
  function lazyLoadImg(){
    var scrollTopPx = $(window).scrollTop();
    $('.load-img').each(function(){
      var $thisImgContainer = $(this);
      if($thisImgContainer.hasClass('load-img--mobile-only')){
        enquire.register("screen and (max-width:767px)", {
          match : function() {
            switchImgSrc($thisImgContainer,scrollTopPx);  
          } 
        }); 
      } else {
        switchImgSrc($thisImgContainer,scrollTopPx);
      }    
    });
  }
  function switchImgSrc(elem,scrollTopPx){
    var thisOffsetTop = $(elem).parent().offset().top - 500;
    var $thisImg = $(elem).children('img');
    if(scrollTopPx >= thisOffsetTop) {
      $thisImg.attr('src',$thisImg.data('original'));
      $(elem).removeClass('load-img');
    }
  }
  if($('.load-img').length){
    lazyLoadImg(); // init
    $(window).on('scroll', function(){ // on scroll
      lazyLoadImg();   
    });
  }

  if($('.lazy').length){ // vendor lazy load
    $('.lazy').lazyload({threshold: 400});
  }

  // Email validation
  function validEmail(value){return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);};

  window.isCustomValid = function($form, isValid){
    var spamControl = $form.find('.spam-control input').val(),
        errorMsg = '',
        errorCount = 0;
    $('.form--error,.form--success').remove();
    $('.input--error').removeClass('input--error');

    $form.find(".input--required").each(function() {
      if (!$(this).val()) {
        $(this).addClass('input--error');
        var fieldTitle = $(this).attr('title');
        if(!fieldTitle) {fieldTitle = $(this).attr('name');}
        errorMsg += 'Please fill in the "'+ fieldTitle +'" field.<br>';
        errorCount++;
      } else if (($(this).is('input[type="email"]') || $(this).attr('name').indexOf('email') != -1) && !validEmail($(this).val())) {
        $(this).addClass('error');
        errorMsg += 'The entered email has an invalid format.<br>';
        errorCount++;
      }
    });

    if (errorCount !== 0 || spamControl !== ''){
      if(!errorCount && spamControl !== ''){errorMsg = 'ERROR';}
      $form.after('<div class="form--error">'+errorMsg+'</div>'); 
    } else {
      isValid();
    }
  };

  // Custom Form Validation & Submission
  $('form.custom-validation button.btn').click(function(e){
    e.preventDefault();
    var $form = $(this).closest('form');
    window.isCustomValid($form, function(){
      $form.submit();
    });
  });

});